import React, { Fragment } from "react";

const DailyMaterialReportInfoSection = ({
  rows,
  fontSizeOverride = null,
  titleWidthOverride = {
    colLong: null,
    col1: null,
    col2: null,
  },
  multiField = {
    // auto-calculate these values
    valWidthOverride: {
      colLong: "125px",
      col1: "125px",
      col2: "125px", // todo: add support for second column
    },
    gapWidth: {
      colLong: "20px",
      col1: "20px",
      col2: "20px", // todo: add support for second column
    },
  },
  centered = false,
}) => {
    let colLongInlineStyle = {};
  let col1TitleInlineStyle = {};
  let col2TitleInlineStyle = {};
  if (titleWidthOverride && typeof titleWidthOverride === "object") {
    titleWidthOverride.colLong &&
    (colLongInlineStyle = { ...colLongInlineStyle, width: titleWidthOverride.colLong, minWidth: titleWidthOverride.colLong });
    titleWidthOverride.col1 &&
      (col1TitleInlineStyle = { ...col1TitleInlineStyle, width: titleWidthOverride.col1, minWidth: titleWidthOverride.col1 });
    titleWidthOverride.col1 &&
      (col2TitleInlineStyle = { ...col2TitleInlineStyle, width: titleWidthOverride.col2, minWidth: titleWidthOverride.col2 });
  }
  return (
    <div style={fontSizeOverride ? { fontSize: fontSizeOverride } : {}}>
      {rows.map((row) => {
        return (
          <div className="report-header-flex-container">
            {centered ? <div className="spacer"></div> : null}
          {row.colLong &&  <div className="report-long-header-property">
              <Fragment>
                <label className="title" style={colLongInlineStyle}>
                  {row.colLong ? `${row.colLong.title}:` : ""}
                </label>
                <div className={`value ${row.colLong ? "" : "no-field"}`}>{row.colLong ? row.colLong.value : ""}</div>
              </Fragment>
            </div> }
        
            <div className="report-header-property">
              {row.col1 && (
                <Fragment>
                  {row.col1.title2 ? (
                    // display two fields instead of one
                    <Fragment>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title}:`}</label>
                      <div className="value" style={{ minWidth: multiField.valWidthOverride.col1 }}>
                        {row.col1.value}
                      </div>
                      <div style={{ minWidth: multiField.gapWidth.col1 }}></div>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title2}:`}</label>
                      <div className="value" style={{ minWidth: multiField.valWidthOverride.col1 }}>
                        {row.col1.value2}
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <label className="title" style={col1TitleInlineStyle}>{`${row.col1.title}:`}</label>
                      <div className="value">{row.col1.value}</div>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </div>
            <div className="spacer"></div>
            <div className="report-header-property">
              <Fragment>
                <label className="title" style={col2TitleInlineStyle}>
                  {row.col2 ? `${row.col2.title}:` : ""}
                </label>
                <div className={`value ${row.col2 ? "" : "no-field"}`}>{row.col2 ? row.col2.value : ""}</div>
              </Fragment>
            </div>
            <div className="spacer"></div>
          </div>
        );
      })}
    </div>
  );
};

export default DailyMaterialReportInfoSection;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/DailyMaterialReportInfoSection.jsx